var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.25 3H5.25C4.14 3 3.25 3.9 3.25 5V19C3.25 20.1 4.14 21 5.25 21H19.25C20.36 21 21.25 20.1 21.25 19V5C21.25 3.9 20.36 3 19.25 3ZM10.25 17L5.25 12L6.66 10.59L10.25 14.17L17.84 6.58L19.25 8L10.25 17Z",
    fill: "#00C853"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckbox);
export default __webpack_public_path__ + "static/media/successCheckbox.089982c5f4f74cb7179df54248ccabd2.svg";
export { ForwardRef as ReactComponent };